module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Heavy-f203775eaf09f4676c8df40da1114483.woff2";